"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsSelectContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
exports.UsSelectContainer = styled_1.default.div `

    .us-select-container {
        position: relative;
        color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$body_color"]};

        .us-select-wrapper {
            margin: 0px;
            list-style: none;
            padding: 0px;
            border: 1px solid ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$main_color"]};
            font-family: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$normal"]};
            font-size: 16px;
            display: none;
            position: absolute;
            top: 43px;
            left: 0;
            z-index: 10;
            background-color: white;
            width: 100%;
            overflow: auto;
            max-height: 250px;

            &.opened {
                display: block;
            }

            &.withLabel {
                top: 73px;
            }

            &.no-space-top {
                top: 25px;
            }

            &.top-overlay {
                top: unset;
                bottom: 43px;
            }

            .us-option-wrapper {
                border-bottom: 1px solid ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$grey"]};
                padding: 10px;
                cursor: pointer;

                &:hover {
                    background-color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$grey"]};
                }

                &.active {
                    color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$main_color"]};
                    font-family: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$bold"]};
                    border: 2px solid ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$light_blue"]};
                }
            }
        }
    }
`;
